export var DEFAULT_BUSINESS = 'hollywood';
export var DEFAULT_MODULE_TYPE = 'default';
export var BINDING_TYPES = ['module', 'all', 'click', 'expose'];
export var MODULE_FIELD_NAME = '模块';